import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import {
    getSplitTestConfiguration,
} from 'wanderu-service-wapi';

import {
    addTestParams,
    setTestOverrides,
    setVisitorId,
    setCachedTestParams,
} from '../../appstate/actions';
import {
    selectVisitorId,
    selectTestData,
} from '../../appstate/selectors';
import sliceNamespace from '../../types';

const logger = Logger.getLogger('wanderu-ducks-split-test:fetchTests');

const namespace = 'FETCH_TESTS';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

function fetchTests(opts) {
    const {
        ip = 'unknown',
        path = '/',
        queryParams = {},
        isServer = false,
        cookieVisitorId,
    } = opts;

    return async (dispatch, getState) => {
        let storedVisitorId = selectVisitorId(getState());
        let error = null;

        dispatch(actions.startWork());

        try {
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                aid: _aid,
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                tid: _tid,
                ...simplifiedQueryParams
            } = queryParams;
            dispatch(setTestOverrides(simplifiedQueryParams));

            if (storedVisitorId === cookieVisitorId) {
                /* either we're on the server, or we are in the browser and have received
                 * a (non-cached) server-side-rendered page; either way we have up-to-date
                 * splittest data so we can skip this */
                return;
            }

            /* most likely we've received a Cloudflare-cached page; don't trust what it says */
            dispatch(setVisitorId(cookieVisitorId));

            const response = await getSplitTestConfiguration({
                id: cookieVisitorId,
                ip,
                path,
                queryParams: simplifiedQueryParams,
            });

            dispatch(addTestParams(response.result));

            if (isServer) {
                /* When receiving a Cloudflare-cached page; store the test config so that we
                * can rerender if the new variant is different */
                const cachedConfigResponse = selectTestData(getState());
                /* eslint-disable-next-line consistent-return */
                return dispatch(setCachedTestParams(cachedConfigResponse));
            }
        } catch (ex) {
            error = ex;
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTests', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
                ip,
                path,
                queryParams,
                isServer,
                resHeaders: ex?.response?.headers,
            });
        } finally {
            dispatch(actions.endWork(undefined, undefined, error));
        }
    };
}

const fetchTestsAction = {
    fetchTests,
    ...selectors,
};

export {
    fetchTestsAction,
};

export default {
    [namespace]: reducer,
};
